import {Link} from 'react-router-dom';
import Particles from "@tsparticles/react";
import { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { TypeAnimation } from "react-type-animation";
import { Carousel } from 'react-bootstrap';
import { useEffect, useState } from "react";
// import * as SimpleIcons from "react-icons/si";
import ParticleOptions from '../components/ParticleOptions';
import ProjectSlide from '../components/ProjectSlide';
import 'bootstrap/dist/css/bootstrap.min.css';

// image imports
import techStackMobile from '../website-images/home-page/tech-stack-mobile.png';
import techStackDesktop from '../website-images/home-page/tech-stack-desktop.png';

function Home() {

    const isDesktop = window.innerWidth >= 768;

    const [init, setInit] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    return (
        <section className="home-page">
            <section className="banner-section">
                {/* Adding particle effect to the banner */}
                    {isDesktop && init && (
                        <Particles
                            id="tsparticles"
                            className="particles-area"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%"
                            }}
                            options={ParticleOptions}
                        />
                    )}
                <div className="hero-text">
                    <h2 className="intro-text">Welcome to my Portfolio Website!</h2>
                    {/* Inserting text that will have a typed effect */}
                    <TypeAnimation
                        className="typed-text"
                        sequence={[
                            "Hi There!", 1500,
                            "I create Websites", 1500,
                            "I am a Web Developer", 1500,
                            "I am a Web Designer", 1500,
                            "And a whole lot more...", 1500,
                            "I am Patrick Neil", 1500,
                        ]}
                        speed={60}
                    />
                    <Link className="project-link grow" to="/projects">View Projects</Link>
                </div>

            </section>
            <section className="about-my-skills">
                {/* use the more rectangular image on wider viewports */}
                <div className="section-content">
                    <img className="home-skills-picture"
                        srcSet={`${techStackMobile} 300w, 
                                ${techStackDesktop} 800w`} 
                        sizes="(max-width: 800px) 300px, 800px"
                        alt="Teck Stack description"/>
                    <div className="about-my-skills-text">
                        <h2>Skills I Offer</h2>
                        <p>
                            The skills I bring into a web development position pertain to both development and design, I am well versed in building responsive websites. This said know how to make websites with Semantic HTML and well structured CSS and SASS. Using JavaScript I am able to make functional websites for my clients. I also have working knowledge of the following JavaScript related libraries: jQuery, Bootstrap and React, I have projects that show my skill in these areas. Not only that but my work in PHP has given me some knowledge on backend web development as well. I am also a team player, I know how to coordinate a team and work on projects with others using GitHub. Also, guess what, this website you're viewing right now was designed by me in Adobe XD, I also have working knowledge of other Adobe products such as photoshop and Illustrator.
                        </p>
                    </div>
                </div>
            </section>

            <section className="prominent-work-section">
                {/* Change the numbers within the array indexes to show different prominent works */}
                <div className="section-content">
                    <h2>Prominent Work</h2>
                    <Carousel>
                    {[4,7,8].map(id => (
                        <Carousel.Item key={id} interval={1000000}>
                            <ProjectSlide ProjectID={id} />
                        </Carousel.Item>
                    ))}
                    </Carousel>
                </div>
            </section>
        </section>
    )
}

export default Home;
